import { useAppDispatch, useAppSelector } from "hooks";
import React, { useEffect } from "react";
import { simFlowFetchData, simFlowFetchSimRequestData } from "../../../../redux/simFlow/simFlowSlice";
import CommonLoader from "components/CommonLoader";
import { parsePublishUpdatesToVehicleHubbody } from "utils/commonFunctions";

type PublishUpdatesToVehicleHubProps = {
  id: any;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
function PublishUpdatesToVehicleHub({ id }: PublishUpdatesToVehicleHubProps) {
  // eslint-disable-next-line sonarjs/no-duplicate-string
  const simSelectorData = useAppSelector((state) => state.simFlow.simFlow.data[4].data);
  const [simSelector, setSimSelector] = React.useState<any>(simSelectorData);

  const simError = useAppSelector((state) => state.errorStep.simError);
  const isError = simError ? simError.step >= 11 : false;
  const isAlreadyFetched =
    simSelectorData instanceof Array
      ? false
      : "status" in simSelectorData
        ? true
        : simSelectorData.flow_dtl_id === Number(id);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!isError && !isAlreadyFetched) {
      dispatch(simFlowFetchData());
      dispatch(simFlowFetchSimRequestData({ id, stepId: 11 }));
    } else {
      setSimSelector(simSelectorData);
    }
  }, [dispatch, id, isAlreadyFetched, isError, simSelectorData]);
  const simSelectorLoading = useAppSelector((state) => state.simFlow.simFlow.loading);

  const metaDataData: Array<any> = [
    {
      id: 1,
      name: "Event Domain",
      value: simSelector.request_json?.metadata?.eventDomain ?? "",
    },
    {
      id: 2,
      name: "Source System",
      value: simSelector.request_json?.metadata?.sourceSystem ?? "",
    },
    {
      id: 3,
      name: "User Id",
      value: simSelector.request_json?.metadata?.userId ?? "",
    },
    {
      id: 4,
      name: "GUID",
      value: simSelector.request_json?.metadata?.GUID ?? "",
    },
    { id: 5, name: "Event Type", value: simSelector.request_json?.metadata?.eventType ?? "" },
    { id: 6, name: "Issue Time", value: simSelector.request_json?.metadata?.issueTime ?? "" },
  ];
  const renderData: Array<any> = [
    {
      id: 4,
      name: "Metadata",
      data: metaDataData,
    },
  ];

  const [parsedData, setParsedData] = React.useState<any>(null);

  useEffect(() => {
    const convert = async () => {
      const convertedData = await parsePublishUpdatesToVehicleHubbody({
        jsonData: simSelector.request_json,
        key: "Publish_Updates_to_Vehicle_Hub",
        page: "simengineflow",
        type: "request",
      });
      // console.log("convertedData", convertedData);
      setParsedData(convertedData);
    };
    convert();
  }, [simSelector]);
  if (simSelectorLoading) {
    return <CommonLoader active={simSelectorLoading} />;
  }

  const VehiclePrice = parsedData?.parsedJsonData?.["Vehicle Price"];
  const VehicleIdentifier = parsedData?.parsedJsonData?.["Vehicle Identifier"];
  const VehicleColor = parsedData?.parsedJsonData?.["Vehicle Color"];
  const factory = parsedData?.parsedJsonData?.["Factory Accessories"];
  const ppo = parsedData?.parsedJsonData?.["PPO Accessories"];
  const ila = parsedData?.parsedJsonData?.["ILA"];

  return (
    <>
      <div className="border border-gray-300 rounded-lg shadow-lg gap-4">
        {parsedData && (
          <>
            {VehicleIdentifier ? (
              <div className="w-full bg-gray-100 rounded-lg py-2 m-2">
                <div className="flex w-full justify-start items-center content-center">
                  <span className="font-bold mx-4 text-xl">Vehicle Identifier</span>
                </div>
                <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
                <div className="grid grid-cols-3 m-4 gap-4">
                  {Object.entries(VehicleIdentifier).map(function ([key, value]) {
                    return (
                      <div className="" key={key}>
                        <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                          <div className="text-base">{key}</div>
                          <div className=" text-base">{value as React.ReactNode}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : null}
            {VehiclePrice ? (
              <div className="w-full bg-gray-100 rounded-lg py-2 m-2">
                <div className="flex w-full justify-start items-center content-center">
                  <span className="font-bold mx-4 text-xl">Vehicle Price</span>
                </div>
                <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
                <div className="grid grid-cols-3 m-4 gap-4">
                  {Object.entries(VehiclePrice).map(function ([key, value]) {
                    return (
                      <div className="" key={key}>
                        <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                          <div className="text-base">{key}</div>
                          <div className=" text-base">{value as React.ReactNode}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : null}
            {VehicleColor ? (
              <div className="w-full bg-gray-100 rounded-lg py-2 m-2">
                <div className="flex w-full justify-start items-center content-center">
                  <span className="font-bold mx-4 text-xl">Vehicle Color</span>
                </div>
                <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
                <div className="grid grid-cols-3 m-4 gap-4">
                  {Object.entries(VehicleColor).map(function ([key, value]) {
                    return (
                      <div className="" key={key}>
                        <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                          <div className="text-base">{key}</div>
                          <div className=" text-base">{value as React.ReactNode}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : null}
            {factory || ppo || ila ? (
              <div className="w-full bg-gray-100 rounded-lg py-2 m-2">
                <div className="flex w-full justify-start items-center content-center">
                  <span className="font-bold mx-4 text-xl">Vehicle Accessories</span>
                </div>
                <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
                <div className="grid grid-cols-1 m-4 gap-4">
                  {factory ? (
                    <div className="">
                      <div className="bg-yellow grid grid-cols-12 m-2 gap-4">
                        <div className="text-base col-span-2">Factory</div>
                        <div className=" text-base col-start-3 col-end-12">
                          {factory.map((item: any) => item).join(", ")}
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {ppo ? (
                    <div className="">
                      <div className="bg-yellow grid grid-cols-12 m-2 gap-4">
                        <div className="text-base col-span-2">PPO</div>
                        <div className=" text-base col-start-3 col-end-12">
                          {ppo.map((item: any) => item).join(", ")}
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {ila ? (
                    <div className="">
                      <div className="bg-yellow grid grid-cols-12 m-2 gap-4">
                        <div className="text-base col-span-2">ILA</div>
                        <div className=" text-base col-start-3 col-end-12">
                          {ila.map((item: any) => item).join(", ")}
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
          </>
        )}
        {renderData.map((item) => {
          return (
            <div className="w-full bg-gray-100 rounded-lg py-2 m-2" key={item.id}>
              <div className="flex w-full justify-start items-center content-center">
                <span className="font-bold mx-4 text-xl">{item.name}</span>
              </div>
              <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
              <div className="grid grid-cols-3 m-4 gap-4">
                {item.data.map((items: any) => (
                  <div className="" key={items.id}>
                    <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                      <div className="text-base">{items.name}</div>
                      <div className=" text-base">{items.value}</div>
                    </div>
                  </div>
                ))}
                <div className="text-base">{item.value}</div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default PublishUpdatesToVehicleHub;
